import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { config_UPTIME } from "../Constants";

const TEST_SITE_KEY = config_UPTIME.url.RECAPTCHA_URL;
const DELAY = 1500;

class ReCaptcha extends React.Component {
  constructor(props, ...args) {
    super(props, ...args);
    this.state = {
      callback: "not fired",
      value: "[empty]",
      load: false,
      expired: "false",
    };
    this._reCaptchaRef = React.createRef();
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ load: true });
    }, DELAY);
    console.log("didMount - reCaptcha Ref-", this._reCaptchaRef);
  }

  handleChange = (value) => {
    console.log("Captcha value:", value);
    this.setState({ value });
    this.props.getCaptchValue(value === null ? "" : value);
    // if value is null recaptcha expired
    if (value === null) this.setState({ expired: "true" });
  };

  asyncScriptOnLoad = () => {
    this.setState({ callback: "called!" });
    console.log("scriptLoad - reCaptcha Ref-", this._reCaptchaRef);
  };

  render() {
    const { value, callback, load, expired } = this.state || {};
    return (
      <div>
        {load && (
          <ReCAPTCHA
            style={{ width: "100%", overflow: "hidden", borderRadius: "5px" }}
            theme="light"
            ref={this._reCaptchaRef}
            sitekey={TEST_SITE_KEY}
            onChange={this.handleChange}
            asyncScriptOnLoad={this.asyncScriptOnLoad}
          />
        )}
      </div>
    );
  }
}

export default ReCaptcha;
